﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["requestType", "requestTypeDescription"];
    }

    requestTypeChangedHandler({ currentTarget }) {
        var selectedValue = currentTarget.options[currentTarget.selectedIndex].value;
        if (selectedValue === "other") {
            this.requestTypeDescriptionTarget.classList.remove("hide");
        }
        else {
            this.requestTypeDescriptionTarget.classList.add("hide");
        }
    }
}
